import { useEffect, useMemo } from 'react';
import { useGetOrganizationClientsQuery } from '../endpoints/client.endpoints';
import { useActiveClient } from 'src/redux/active-client/use-active-client';
import { Client } from '../types/client.types';

/**
 * Returns the active client from the RTK Query cache when available,
 * falling back to the Redux snapshot set when the drawer was opened.
 */
export function useLiveActiveClient(): Client | null {
  const { activeClient, activeClientId, setClient } = useActiveClient();
  const { data: clients } = useGetOrganizationClientsQuery();

  const liveClient = useMemo(() => {
    if (!activeClientId) {
      return activeClient;
    }
    return clients?.find((client) => client.ext_client_id === activeClientId) ?? activeClient;
  }, [clients, activeClientId, activeClient]);

  useEffect(() => {
    if (!liveClient || !activeClient) {
      return;
    }
    if (liveClient.ext_client_id !== activeClient.ext_client_id) {
      return;
    }
    if (liveClient !== activeClient) {
      setClient(liveClient);
    }
  }, [liveClient, activeClient, setClient]);

  return liveClient;
}
